export default "__VITE_ASSET__CkZ6MyCj__"